<script>
    import TopBar from '../components/TopBar.svelte';
    import Login from '../components/common/Login.svelte';
</script>

<div class="page-container">
    <TopBar />
    <div style="margin-top: 20vh;"></div>
    <Login />
    <div class="black-div"></div>

    <footer class="footer">
        <p>&copy; 2023 Boanalys. All rights reserved.</p>
        <p>Contact: <a href="mailto:info@boanalys.io">info@boanalys.io</a></p>
    </footer>
</div>

<style>

    footer {
        z-index: 2;
        position: fixed;
    }
    
</style>